import { type MutationError, trpc } from '@/shared/api';

interface UseRemoveRecommendedProductOptions {
  readonly onSuccess?: () => void;
}

/** 추천에서 뺀다(추천 순위를 비운다). 남은 상품은 서버가 다시 매긴다. */
export const useRemoveRecommendedProduct = ({
  onSuccess,
}: UseRemoveRecommendedProductOptions = {}) => {
  const mutation = trpc.productManagement.recommendations.remove.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    removeProduct: (productId: string) => mutation.mutate({ productId }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
